import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FaxTypes } from 'generated/graphql-types';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { FaxFilterOptions } from '../../models/fax-filter-option';
import { FaxOrderingOptions, FaxRegisterOptions } from '../../models/fax-register-options';
import { FaxRegisterListItem } from '../../models/fax-register-results.model';
import * as incomingFaxRegisterActions from '../state/incoming-fax-register.actions';
import {
   incomingFaxRegisterAdapterActions,
   incomingFaxRegisterInitialFilter,
} from '../state/incoming-fax-register.actions';
import * as incomingFaxRegisterReducer from '../state/incoming-fax-register.reducer';
import { selectQuickFilters } from '../state/incoming-fax-register.reducer';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-incoming-fax-register',
    styleUrls: [],
    templateUrl: './incoming-fax-register.component.html',
    standalone: false
})
export class IncomingFaxRegisterComponent
   extends Register<FaxRegisterListItem, FaxRegisterOptions, FaxOrderingOptions>
   implements OnInit
{
   entityName = 'Fax';

   columns: string[] = ['createDate', 'faxSource', 'faxDestination', 'faxStatus', 'detail'];

   filters: FaxFilterOptions[];

   private _extensionId: number;

   @Input() get extensionId(): number {
      return this._extensionId;
   }

   onOpenDialog(event: { faxLogs: any }) {
      this.store.dispatch(incomingFaxRegisterActions.openDialog(event));
   }

   set extensionId(value: number) {
      this._extensionId = value;
      this.filters = this.buildFilters();
   }

   constructor(public store: Store) {
      super(store, incomingFaxRegisterReducer.selectors, incomingFaxRegisterAdapterActions);
   }

   ngOnInit() {
      this.store.dispatch(incomingFaxRegisterInitialFilter({ filters: this.filters, quickFilters: [] }));
      this.store.dispatch(incomingFaxRegisterAdapterActions.pageEnter());
   }

   ngOnChanges(changes: SimpleChanges) {
      if (changes['extensionId'] && !changes['extensionId'].firstChange) {
         this.store.select(selectQuickFilters).subscribe((quickFilters) => {
            if (quickFilters) {
               this.filters = this.buildFilters();
               this.store.dispatch(
                  incomingFaxRegisterInitialFilter({
                     filters: this.filters,
                     quickFilters: quickFilters,
                  })
               );
               this.store.dispatch(incomingFaxRegisterAdapterActions.pageEnter());
            }
         });
      }
   }

   private buildFilters(): FaxFilterOptions[] {
      const filters: FaxFilterOptions[] = [
         {
            field: 'ExtensionId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: this.extensionId,
         },
         {
            field: 'FaxTypeId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: FaxTypes.Received as unknown as number,
         },
      ];
      return filters;
   }
}
